import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue16, isVariable } from '../../../../Fct/generics';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { A_TOKENS, LENDING_POOL_ADDRESSES } from '../constants';
export var Borrow = createPlugin({
    protocol: 'AAVE',
    type: 'ACTION',
    method: 'borrow',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }) }),
                    amount: new FctValue({ destination: 'wei_amount' }),
                    interestRateMode: new FctValue({ options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }] }),
                    referralCode: new FctValue16({}),
                    onBehalfOf: new FctAddress({}),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: {
            referralCode: '0', // Aave has disabled referral codes, 0 by default
        },
    },
    requiredApprovals: function (params, chainId, _walletAddress, vaultAddress, _provider, _method, isEstimation) {
        var _a = params.methodParams, amount = _a.amount, onBehalfOf = _a.onBehalfOf, asset = _a.asset;
        var assetValue = asset.value;
        if (assetValue && typeof assetValue != 'string') {
            return [];
        }
        var fromTokenData = A_TOKENS[chainId].find(function (token) { return token.underlyingAssetAddress.toLowerCase() === assetValue.toLowerCase(); });
        if (!fromTokenData) {
            return [];
        }
        if (!vaultAddress)
            return [];
        var getValue = function () {
            if (isEstimation && isVariable(amount.value)) {
                return amount.estimatedValue;
            }
            return amount.value;
        };
        var value = getValue();
        if (!value)
            return [];
        return [
            {
                to: fromTokenData.aTokenAddress,
                from: onBehalfOf.value,
                params: { delegatee: vaultAddress, amount: value },
                method: 'approveDelegation',
                protocol: 'AAVE',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, _b = params.methodParams, amount = _b.amount, interestRateMode = _b.interestRateMode, asset = _b.asset, onBehalfOf = _b.onBehalfOf;
        if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !interestRateMode.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' ||
            typeof interestRateMode.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof to.value !== 'string')
            return [];
        var tokenData = (_a = A_TOKENS[chainId]) === null || _a === void 0 ? void 0 : _a.find(function (token) { return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase(); });
        if (!tokenData)
            return [];
        var debtToken = interestRateMode.value === '1' ? tokenData.stableDebtTokenAddress : tokenData.variableDebtTokenAddress;
        return [
            {
                address: vaultAddress,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                    {
                        token: debtToken,
                        amount: amount.value,
                    },
                ],
            },
        ];
    },
});
